module.exports = __webpack_public_path__ + "static/media/echrini.firebaseapp.com_products(Laptop with MDPI screen).ebde7798.png";